// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyA6vQeL0gXf1E8m7kkygYF1kaiyg-b9uIU",
    authDomain: "yallago-23631.firebaseapp.com",
    projectId: "yallago-23631",
    storageBucket: "yallago-23631.appspot.com", // ✅ fixed URL
    messagingSenderId: "563902139845",
    appId: "1:563902139845:web:11713920af4ac42fb58fac",
    measurementId: "G-V896N7W8JY"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

isSupported().then((ok) => {
    if (ok) getAnalytics(app);
});

export { db, auth };
